import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  field: {
    marginTop: theme.spacing(4),
  },
}));
